import api from "../../../api/api";
import { STORAGE_KEY } from "./constant";

export async function setSession(accessToken: string | null,key?:string) {
    try {
      if (accessToken) {
        localStorage.setItem(key?key:STORAGE_KEY, accessToken);
  
        // api.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  
       
      } else {
        localStorage.removeItem(STORAGE_KEY);
        delete api.defaults.headers.common.Authorization;
      }
    } catch (error) {
      console.error('Error during set session:', error);
      throw error;
    }
  }
  